// extracted by mini-css-extract-plugin
export default {"link":"Settings-link-errh1 Link-link-RInnp","summary":"Settings-summary-eUl9k"};